interface PermissionInterface {
    id: number;
    name: string;
    description: string;
}

class Permission implements PermissionInterface {
    static readonly USERS_READ: string                     = 'users.READ';
    static readonly USERS_READ_ALL: string                 = 'users.READ_ALL';
    static readonly USERS_WRITE: string                    = 'users.WRITE';
    static readonly USERS_WRITE_ALL: string                = 'users.WRITE_ALL';
    static readonly ROLES_READ: string                     = 'roles.READ';
    static readonly ROLES_WRITE: string                    = 'roles.WRITE';
    static readonly LANGUAGES_READ: string                 = 'languages.READ';
    static readonly LANGUAGES_WRITE: string                = 'languages.WRITE';
    static readonly MESSAGES_READ: string                  = 'messages.READ';
    static readonly MESSAGES_WRITE: string                 = 'messages.WRITE';
    static readonly COMPANIES_READ: string                 = 'companies.READ';
    static readonly COMPANIES_WRITE: string                = 'companies.WRITE';
    static readonly BASES_READ: string                     = 'bases.READ';
    static readonly BASES_WRITE: string                    = 'bases.WRITE';
    static readonly ATTACHMENTS_READ: string               = 'attachments.READ';
    static readonly PERMISSIONS_READ: string               = 'permissions.READ';
    static readonly PERMISSIONS_WRITE: string              = 'permissions.WRITE';
    static readonly MESSAGES_SHOW_OVERVIEW: string         = 'messages.SHOW_OVERVIEW';
    static readonly MESSAGES_WRITE_NEW_MESSAGES: string    = 'messages.WRITE_NEW_MESSAGES';
    static readonly MESSAGES_CHECK_MESSAGES: string        = 'messages.CHECK_MESSAGES';
    static readonly MESSAGES_EDIT_MESSAGES: string         = 'messages.EDIT_MESSAGES';
    static readonly MESSAGES_DELETE: string                = 'messages.DELETE';
    static readonly MESSAGECENTRAL_READ: string            = 'messagecentral.READ';
    static readonly MESSAGECENTRAL_WRITE: string           = 'messagecentral.WRITE';
    static readonly MESSAGES_IMPORT_POKES: string          = 'messages.IMPORT_POKES';
    static readonly STATISTICS_MESSAGES: string            = 'statistics.MESSAGES';
    static readonly INSIGHTS_PROFILES_PER_GEO: string      = 'insights.PROFILES_PER_GEO';
    static readonly INSIGHTS_PROFILES_PER_IP_LEVEL: string = 'insights.PROFILES_PER_IP_LEVEL';
    static readonly STATISTICS_USER_PERFORMANCE: string    = 'statistics.USER_PERFORMANCE';
    static readonly MESSAGES_STATISTICS_READ: string       = 'messages.statistics.READ';
    static readonly SCHEMAS_SHOW_OVERVIEW: string          = 'schemas.SHOW_OVERVIEW';

    id: number;
    name: string;
    description: string;
}

export {
    PermissionInterface,
    Permission
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/permissions/api.models.ts